<template>
  <div class="wrapper font-body-m" :class="{high: high}" :style="styleWrapper">
    <div class="is-flex is-justify-content-center">
      <p class="is-inline-block"
         :class="{active: active === 'left', mirror}"
         v-on:click="$emit('click', 'left')">
        <b v-if="textPosition === 'left'">{{ text }}</b>
        <b v-else-if="textPosition === 'both'">{{ text }}</b>
      </p>


      <img class="is-clickable"
           :class="{mirror: mirror}"
           src="@/assets/landing-pages/forPeople/2023/dotted-arrow.svg"
           v-on:click="$emit('click')"
           alt="Next"/>

      <p class="is-inline-block right"
         :class="{
            active: active === 'right' || textPosition === 'right',
            mirror
          }"
         v-on:click="$emit('click', 'right')"
      >
        <b v-if="textPosition === 'right'">{{ text }}</b>
        <b v-else-if="textPosition === 'both'">{{ text2 }}</b>
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  position: absolute;
  z-index: 50;
  left: 0;
  right: 0;

  &.high {
    bottom: 150px;
  }

  &:not(.high) {
    bottom: -80px;
  }

  p {
    display: block;
    margin-top: 70px;
    width: 150px;
    text-align: right;
    opacity: 0.3;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }

    &.active {
      opacity: 1;
    }

    &.mirror {
      margin-right: 1rem;
    }

    &.right {
      text-align: left;
      margin-left: 1rem;

      &.mirror {
        margin-left: 0;
      }
    }
  }

  img.mirror {
    transform: scaleX(-1);
  }
}
</style>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OArrowDownScroll extends Vue {
  @Prop({ default: false })
  clickOnContainer!: boolean;

  @Prop({ default: true })
  high!: boolean;

  @Prop({ default: false })
  mirror!: boolean;

  @Prop({ default: 'left' })
  active!: 'left' | 'right';

  @Prop({ default: '' })
  text!: string;

  @Prop({ default: '' })
  text2!: string;

  @Prop({ default: 'left' })
  textPosition!: 'left' | 'right' | 'both';

  @Prop({ default: () => {} })
  styleWrapper!: any;
}
</script>
